import React from 'react';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import Benefits from '../components/Benefits';
import Founder from '../components/Founder';

const Home = () => {
  return (
    <main>
      <Hero />
      <HowItWorks />
      <Benefits />
      <Founder />
    </main>
  );
};

export default Home;